export default __webpack_public_path__ + "static/media/reload.84355e2c.svg";